export var join = function join(separator) {
  return function (elements) {
    return elements.join(separator);
  };
};